var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDealerMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "50px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9155 2C10.4805 2 9.07122 2.39108 7.84129 3.12904C5.46089 4.55727 4 7.13211 4 9.90941C4 11.47 4.46194 12.9957 5.3276 14.2942L9.61325 20.7227C10.1453 21.5207 11.0409 22 12 22C12.9591 22 13.8547 21.5207 14.3868 20.7227L18.6724 14.2942C19.5381 12.9957 20 11.47 20 9.90941C20 7.1321 18.5391 4.55727 16.1587 3.12904C14.9288 2.39108 13.5195 2 12.0845 2H11.9155Z",
    fill: "#4296FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8ZM8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10Z",
    fill: "#152C70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerMarker);
export default __webpack_public_path__ + "static/media/DealerMarker.c5bb17584348dfda6bf67ce42d598b3b.svg";
export { ForwardRef as ReactComponent };